import React, { useEffect, useRef } from 'react';

import Flag from 'react-world-flags';
import { countries } from 'country-list-json';
import { Modal, InputGroup, FormControl } from 'react-bootstrap';

import './SelectCountryModal.css';

const SelectCountryModal = ({
    show,
    onClose,
    onSelectCountry,
    searchTerm,
    setSearchTerm,
}) => {
    const searchInputRef = useRef(null);

    const filteredCountries = countries.filter(country =>
        country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        country.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
        country.dial_code.includes(searchTerm)
    );

    useEffect(() => {
        if (show) {
            searchInputRef.current?.focus();
        }
    }, [show]);

    return (
        <Modal
            centered
            show={show}
            onHide={onClose}
            className='customer-modal-without-header-footer select-country-modal'
        >
            <Modal.Header>
                <InputGroup className="mb-3">
                    <FormControl
                        placeholder="Search Country"
                        aria-label="Search Country"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        ref={searchInputRef}
                    />
                </InputGroup>
            </Modal.Header>
            <Modal.Body>
                {filteredCountries.map((country) => (
                    <div
                        key={country.code}
                        className='flag-item'
                        onClick={() => onSelectCountry(country.code)}
                    >
                        <Flag code={country.code} style={{ width: '24px', height: '18px', marginRight: '10px' }} />
                        <p className='text-start'>{country.name} ({country.dial_code})</p>
                    </div>
                ))}
            </Modal.Body>
        </Modal>
    );
};

export default SelectCountryModal;
